import React from 'react';
import {View, Text} from 'react-native';
import {useSelector} from 'react-redux';

import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

import FlagButton from 'src/Modules/FlagButton';

import UserProfileIcon from 'src/Modules/UserProfileIcon';

import EventLeaderboardCompact from '../CustomEvents/EventLeaderboardCompact';
import {ordinalSuffixOf} from '../Utils/helpers';
import {ScrollView} from 'react-native-gesture-handler';

const LocalLeaderboard = () => {
  const localLeaderboard = useSelector((state) => state.local.localLeaderboard);
  let place = 3;
  let previousHigherScore = 0;
  const {width} = useWindowDimensionsSafe();
  return (
    <View style={{flex: 1}}>
      <ScrollView>
        <EventLeaderboardCompact
          groupsOverride={localLeaderboard}
          backgroundStyle={{height: 350}}
          title={`Let's Roam Local Leaderboard`}
          body={`Here are the 25 top rated players and contribitors for Let's Roam Local. Top spots win swag and prizes every month.`}
        />
        <View>
          {!!localLeaderboard &&
            localLeaderboard.slice(3, 25)?.map?.((group) => {
              let photoUrl = group?.photo_url;
              if (previousHigherScore != group.points) {
                previousHigherScore = group.points;
                place = place + 1;
              }
              if (!photoUrl && group.players) {
                let firstPlayer = Object.values(group.players)[0];
                photoUrl = firstPlayer.photoUrl;
              }

              let backgroundColor = global?.color?.orange;
              if (place % 4 == 1) {
                backgroundColor = global?.color?.yellow;
              } else if (place % 4 == 2) {
                backgroundColor = global?.color?.gray2;
              } else if (place % 4 == 0) {
                backgroundColor = global?.color?.teal;
              } else if (place % 4 == 3) {
                backgroundColor = global?.color?.orange;
              }

              return (
                <View
                  key={`${group.groupId}_ldrbrd`}
                  style={{
                    marginLeft: 5,
                    width: width,
                    marginBottom: 10,
                    height: 85,
                  }}>
                  <View
                    style={{
                      position: 'absolute',
                      left: 50,
                      paddingTop: 5,
                    }}>
                    <FlagButton
                      width={width - 70}
                      orientation={'left'}
                      height={60}
                      color={backgroundColor}
                    />
                  </View>
                  <View
                    style={{
                      position: 'absolute',
                      left: 100,
                      top: 4,
                      right: 30,
                    }}>
                    <Text
                      style={{
                        fontFamily: 'Alternate Gothic No3 D',
                        fontSize: 20,
                        color: 'white',
                      }}>
                      {ordinalSuffixOf(place == 0 ? 1 : place) + ' Place'}
                    </Text>
                    <Text
                      style={{
                        fontFamily: 'Alternate Gothic No3 D',
                        fontSize: 20,
                        color: 'white',
                      }}>
                      {group.first_name}
                    </Text>
                    <Text
                      style={{
                        fontFamily: 'Alternate Gothic No3 D',
                        fontSize: 13,
                        color: 'white',
                      }}>
                      {'Score: ' + (group?.points || 0)}
                    </Text>
                  </View>

                  <View style={{position: 'absolute', left: 0, paddingTop: 5}}>
                    <UserProfileIcon
                      user={{
                        info: {
                          firstName: group?.first_name,
                          photoUrl: group?.photo_url,
                        },
                      }}
                    />
                  </View>
                </View>
              );
            })}
        </View>
      </ScrollView>
    </View>
  );
};

export default LocalLeaderboard;
